import { useMemo } from 'react';
import { useAccessFeatures } from '../../auth/useAccessFeatures';
import { navSectionsFor, type NavSection } from './navSections';

export function useNavSections(): NavSection[] {
    // Same source as RequireAccess and DefaultLanding.
    const { features } = useAccessFeatures();
    const key = features.join(',');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useMemo(() => navSectionsFor(features), [key]);
}
